export const typeKeys = {
  primary: 'primary',
  primaryInvert: 'primary-invert',
  secondary: 'secondary',
};

export const sizeKeys = { md: 'md', lg: 'lg' };

export const sizes = new Set(Object.values(sizeKeys));
export const types = new Set(Object.values(typeKeys));
